export default "__VITE_ASSET__HtYfz$FP__"